import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

export const cloudConfigured = Boolean(url && anonKey)
export const supabase = cloudConfigured ? createClient(url!, anonKey!) : null
export const tenantId = (import.meta.env.VITE_TENANT_ID as string | undefined) ?? 'hdm'
export const adminEmail = (import.meta.env.VITE_ADMIN_EMAIL as string | undefined) ?? 'novin.jafarii@gmail.com'

